/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { IMG, Text, Stack } from "..";
import { FC } from "react";
import { useEventTheming } from "state/AppThemingContext";

type Props = {
  image: string
  title: string
  isSelected?: boolean
}

const EventsCard: FC<Props> = ({ image, title, isSelected }) => {
  const { theming } = useEventTheming();
  return (
    <Stack
      className={cn(
        "relative min-w-[300px] h-[150px] overflow-hidden border-[3px] border-transparent hover:-border--theme-colors-text-title-brand transition -rounded-event-card",
        {
          "!-border--theme-colors-text-title-brand": isSelected,

        }
      )}
    >
      <IMG
        className="absolute w-full h-full object-cover"
        src={image || theming?.system_placeholder}
      />
      <div className="absolute w-full h-full opacity-70" style={{
        background: `linear-gradient(0deg, var(--component-colors-event-card-overlay, rgba(220, 223, 251, 0.80)) 0%, var(--component-colors-event-card-overlay, rgba(220, 223, 251, 0.80)) 100%), lightgray 50% / cover no-repeat`
      }}></div>
      <Text as="h3" className="font-bold text-lg -text--theme-colors-text-title z-0 mt-4 ms-4">
        {title}
      </Text>
    </Stack>
  );
};

export default EventsCard;
